import { NgModule } from '@angular/core';
import { PipelineSidePanelComponent } from './pipeline-side-panel.component';
import { SlideOutPanelModule } from '../../slide-out-panel/slide-out-panel.module';
import { CommonModule } from '@angular/common';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { TranslateModule } from '@ngx-translate/core';
import { OpportunityDetailsModule } from '../../sales-opportunities/opportunity-side-panel/opportunity-details/opportunity-details.module';
import { CreateOpportunityModule } from '../../sales-opportunities/opportunity-side-panel/create-opportunity/create-opportunity.module';
@NgModule({
  declarations: [PipelineSidePanelComponent],
  exports: [PipelineSidePanelComponent],
  imports: [
    CommonModule,
    SlideOutPanelModule,
    GalaxyEmptyStateModule,
    MatIconModule,
    MatButtonModule,
    MatExpansionModule,
    TranslateModule,
    OpportunityDetailsModule,
    CreateOpportunityModule,
  ],
})
export class PipelineSidePanelModule {}
